import React from "react";
import { IoMdClose } from "react-icons/io";
import Avatar from "react-avatar";
import moment from "moment";

const PostsModal = ({ profileData, isOpen, onClose }) => {
  if (!isOpen || !profileData) return null;

  const mediaPreview = () => {
    if (profileData.media_type === "reel" && profileData.media_url) {
      return (
        <video
          src={profileData.media_url}
          controls
          className="mt-4 w-full rounded-xl"
          poster={profileData.media_thumbnail || undefined}
        />
      );
    }

    const thumbnail =
      profileData.media?.[0] ||
      profileData.media_thumbnail ||
      profileData.media_url;

    if (thumbnail) {
      return (
        <img
          src={thumbnail}
          alt="media"
          className="mt-4 w-full rounded-xl object-cover"
        />
      );
    }

    return null;
  };

  const account = profileData.accountDetails || {};

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 p-2 sm:p-4">
      <div className="max-h-[90vh] w-[95%] sm:w-[720px] overflow-auto rounded-xl bg-navy-800 px-3 pb-3 sm:px-6 sm:pb-6 shadow-lg">
        <div className="flex justify-end py-2 sm:py-3">
          <IoMdClose className="cursor-pointer text-xl sm:text-2xl" onClick={onClose} />
        </div>

        <div className="flex items-center gap-3 sm:gap-4">
          {account.profilepic ? (
            <img
              src={account.profilepic}
              alt="profile"
              className="h-12 w-12 sm:h-16 sm:w-16 rounded-full object-cover"
            />
          ) : (
            <Avatar
              name={account.name || account.username || "Post"}
              className="!h-12 !w-12 sm:!h-16 sm:!w-16 rounded-full"
            />
          )}
          <div className="flex flex-col">
            <p className="text-base sm:text-lg font-semibold text-white">
              {account.username || "--"}
            </p>
            <p className="text-xs sm:text-sm capitalize text-gray-300">
              {account.account_type || "personal"}
            </p>
          </div>
        </div>

        {mediaPreview()}

        <div className="mt-4 sm:mt-6 space-y-3 sm:space-y-4">
          <div>
            <h4 className="text-xs sm:text-sm font-semibold uppercase text-gray-600">
              Caption
            </h4>
            <p className="mt-1 break-words text-sm sm:text-base text-white">
              {profileData.caption || "--"}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-xs sm:text-sm text-white">
            <div>
              <p className="text-xs uppercase text-gray-600">Post Type</p>
              <p className="capitalize text-xs sm:text-sm">{profileData.post_type || "--"}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Media Type</p>
              <p className="capitalize text-xs sm:text-sm">{profileData.media_type || "--"}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Likes</p>
              <p className="text-xs sm:text-sm">{profileData.likecount ?? 0}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Comments</p>
              <p className="text-xs sm:text-sm">{profileData.commentcount ?? 0}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Shares</p>
              <p className="text-xs sm:text-sm">{profileData.sharecount ?? 0}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Pinned</p>
              <p className="text-xs sm:text-sm">{profileData.is_pinned ? "Yes" : "No"}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Created At</p>
              <p className="text-xs sm:text-sm">
                {profileData.created_at
                  ? moment(profileData.created_at).format(
                      "DD/MM/YYYY hh:mm A"
                    )
                  : "--"}
              </p>
            </div>
            <div>
              <p className="text-xs uppercase text-gray-600">Scale</p>
              <p className="text-xs sm:text-sm">{profileData.scale || "--"}</p>
            </div>
            <div className="col-span-1 sm:col-span-2">
              <p className="text-xs uppercase text-gray-600">Location</p>
              {profileData.location ? (
                <p className="text-xs sm:text-sm">
                  Lat: {profileData.location.lat ?? "--"}, Lng: {" "}
                  {profileData.location.lng ?? "--"}
                </p>
              ) : (
                <p className="text-xs sm:text-sm">--</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostsModal;
